import styled from 'styled-components';
import { FormModal } from 'newComponents/Modal';
import { colors } from 'assets/styled/tokens';

export const StyledModal = styled(FormModal)``;

export const ModalContent = styled.div`
  padding: 21px 16px;
  display: flex;
  flex-direction: column;
  min-width: 0;
  width: 100%;
  box-sizing: border-box;
`;

export const ButtonsRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const SaveButton = styled.button`
  width: 64px;
  height: 32px;
  border-radius: 6px;
  padding: 8px 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${colors.primary};
  color: #fff;
  font-family: Roboto;
  font-weight: 700;
  font-style: Bold;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.3px;
  border: none;
  cursor: pointer;
`;

export const CleanFilter = styled.button`
  width: 132px;
  height: 32px;
  padding: 8px 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 6px;
  border: 1px solid #e8e1de;
  font-family: Roboto;
  font-weight: 700;
  font-style: Bold;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.3px;
  color: #c25346;
  background-color: transparent;
  cursor: pointer;
  svg {
    path {
      fill: #ec6655;
    }
  }
`;
